import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { getProductionLabelKeys } from '../../utils/common';

const useStyles = makeStyles(() => ({
  tag: {
    fontStyle: 'italic',
    paddingRight: '0.1rem',
    display: 'inline-block',
  },
}));

const TagsDivider = ({ tags }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {tags.map((tag, index) => (
        <div className={classes.tag} key={tag?.id}>
          {Boolean(index) && <> &#8226; </>}
          <span>{t(getProductionLabelKeys(tag?.id))}</span>
        </div>
      ))}
    </>
  );
};

export default TagsDivider;
